import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from './authentication.guard';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AppointDistrictOffBearerComponent } from './districtadmin-menu/appoint-district-off-bearer/appoint-district-off-bearer.component';
import { CreateOffBearerComponent } from './districtadmin-menu/create-off-bearer/create-off-bearer.component';
import { DaDashboardComponent } from './districtadmin-menu/da-dashboard/da-dashboard.component';
import { DaMeetingComponent } from './districtadmin-menu/da-meeting/da-meeting.component';
import { DistrictadminMenuComponent } from './districtadmin-menu/districtadmin-menu.component';
import { CourseDistrictComponent } from './districtadmin-menu/course-district/course-district.component';
import { DistrictwiseEngReportComponent } from './districtadmin-menu/districtwise-eng-report/districtwise-eng-report.component';
import { ReqOffBearerChangeComponent } from './districtadmin-menu/req-off-bearer-change/req-off-bearer-change.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { StudentDashboardComponent } from './student-dashboard/student-dashboard.component';
import { DashboardComponent as StDashboardComponent } from './student-dashboard/dashboard/dashboard.component';
import { CourseComponent as StCourseComponent } from './student-dashboard/course/course.component';
import { DashboardComponent as MtDashboardComponent } from './mentor-dashboard/dashboard/dashboard.component';
import { SelfRegistrationComponent } from './self-registration/self-registration.component';
import { CreateMeetingsComponent } from './stateadmin-menu/create-meetings/create-meetings.component';
import { ReportAllDistrictComponent } from './stateadmin-menu/report-all-district/report-all-district.component';
import { SADashboardComponent } from './stateadmin-menu/sa-dashboard/sa-dashboard.component';
import { SentMeetingsNotifyComponent } from './stateadmin-menu/sent-meetings-notify/sent-meetings-notify.component';
import { StateadminMenuComponent } from './stateadmin-menu/stateadmin-menu.component';
import { AddtionalPostReqApprovalComponent } from './superadmin-dashboard/addtional-post-req-approval/addtional-post-req-approval.component';
import { AppOrRejComponent } from './superadmin-dashboard/app-or-rej/app-or-rej.component';
import { DashboardComponent } from './superadmin-dashboard/dashboard/dashboard.component';
import { DistrictadminComponent } from './superadmin-dashboard/districtadmin/districtadmin.component';
import { MeetingsComponent } from './superadmin-dashboard/meetings/meetings.component';
import { OfficeBearerApprovalComponent } from './superadmin-dashboard/office-bearer-approval/office-bearer-approval.component';
import { ReportsComponent } from './superadmin-dashboard/reports/reports.component';
import { CourseComponent } from './superadmin-dashboard/course/course.component';
import { ActivityComponent } from './superadmin-dashboard/activity/activity.component';
import { ActivitySummaryComponent } from './superadmin-dashboard/activity-summary/activity-summary.component';
import { MentorComponent } from './superadmin-dashboard/mentor/mentor.component';
import { SignOutComponent } from './superadmin-dashboard/sign-out/sign-out.component';
import { StateadminComponent } from './superadmin-dashboard/stateadmin/stateadmin.component';
import { StudentRegisterComponent } from './superadmin-dashboard/student-register/student-register.component';
import { SuperadminDashboardComponent } from './superadmin-dashboard/superadmin-dashboard.component';
import { MenuChangePasswordComponent } from './menu-change-password/menu-change-password.component';
import { DaReportComponent } from './superadmin-dashboard/da-report/da-report.component';
import { ObLoginComponent } from './ob-login/ob-login.component';
import { ObReportComponent } from './superadmin-dashboard/ob-report/ob-report.component';
import { ProfileDetailsComponent } from './profile-details/profile-details.component';
import { DaAddressreportComponent } from './da-addressreport/da-addressreport.component';
import { ZoneReportComponent } from './superadmin-dashboard/zone-report/zone-report.component';
import { Kalaignar100Component } from './kalaignar100/kalaignar100.component';
import { Kalaignar100ReportComponent } from './kalaignar100-report/kalaignar100-report.component';
import { MentorDashboardComponent } from './mentor-dashboard/mentor-dashboard.component';
import { MentorSessionComponent } from './mentor-dashboard/mentor-session/mentor-session.component';
import { StudentIndexComponent } from './superadmin-dashboard/student-index/student-index.component';
import { MentorIndexComponent } from './superadmin-dashboard/mentor-index/mentor-index.component';
import { SuperCourseAttendanceComponent } from './superadmin-dashboard/super-course-attendance/super-course-attendance.component';
import { StudentChangePasswordComponent } from './student-dashboard/student-change-password/student-change-password.component';
import { MentorChangepasswordComponent } from './mentor-dashboard/mentor-changepassword/mentor-changepassword.component';
import { DastudentlistComponent } from './districtadmin-menu/dastudentlist/dastudentlist.component';
import { DaMentorlistComponent } from './districtadmin-menu/da-mentorlist/da-mentorlist.component';
import { CourseAssignedComponent } from './mentor-dashboard/course-assigned/course-assigned.component';
// import { StdashboardComponent } from './student-dashboard/stdashboard/stdashboard.component';
import { MtdashboardComponent } from './mentor-dashboard/mtdashboard/mtdashboard.component';
import { CourseAttendanceComponent } from './districtadmin-menu/course-attendance/course-attendance.component';
import { VolunteerSessionComponent } from './districtadmin-menu/volunteer-session/volunteer-session.component';
import { StudentFeedbackComponent } from './student-dashboard/student-feedback/student-feedback.component';
import { MentorFeedbackComponent } from './mentor-dashboard/mentor-feedback/mentor-feedback.component';
import { DaStudentFeedbackComponent } from './districtadmin-menu/da-student-feedback/da-student-feedback.component';
import { DaMentorFeedbackComponent } from './districtadmin-menu/da-mentor-feedback/da-mentor-feedback.component';
import { MentorlistComponent } from './mentorlist/mentorlist.component';

import { MentorStudentCourseComponent } from './student-dashboard/mentor-student-course/mentor-student-course.component';
import { MentorstudentrequestComponent } from './mentorstudentrequest/mentorstudentrequest.component';
import { MentorstudentgrouprequestComponent } from './mentorstudentgrouprequest/mentorstudentgrouprequest.component';
import { StudentEnrollComponent } from './mentor-dashboard/student-enroll/student-enroll.component';
import { StudentRequestListComponent } from './student-dashboard/student-request-list/student-request-list.component';
import { StudentGroupRequestListComponent } from './student-dashboard/student-group-request-list/student-group-request-list.component';


import { MentorVolunteerComponent } from './mentor-dashboard/mentor-volunteer/mentor-volunteer.component';
import { DaMentorVolunteerComponent } from './districtadmin-menu/da-mentor-volunteer/da-mentor-volunteer.component';
import { VerifyOtpComponent } from './verify-otp/verify-otp.component';
import { MentorCreateCourseListComponent } from './superadmin-dashboard/mentor-create-course-list/mentor-create-course-list.component';





const routes: Routes = [
  // {path:"", component: LoginComponent, pathMatch: 'full'},
  {path:"change-password/:email/:token", component: ChangePasswordComponent},
  { path: "change-password/:email", component: ChangePasswordComponent },
  {path:"verify-otp", component: VerifyOtpComponent},
  { path: "students", component: StudentRegisterComponent },
  { path:"mentor",  component: MentorComponent},
  {path:"superadmin",  canActivate: [AuthenticationGuard],component: SuperadminDashboardComponent,
        children: [
          { path: '',  component: DashboardComponent},
          { path: 'Dashboard',canActivate: [AuthenticationGuard],  component: DashboardComponent},
          { path: 'Districtadmin', canActivate: [AuthenticationGuard], component: DistrictadminComponent},
          { path:"Stateadmin", canActivate: [AuthenticationGuard], component: StateadminComponent},
          { path:"superadminstudents", canActivate: [AuthenticationGuard], component: StudentIndexComponent},
          { path:"superadminmentors", canActivate: [AuthenticationGuard], component: MentorIndexComponent},
       { path:"attendance",canActivate: [AuthenticationGuard],  component: SuperCourseAttendanceComponent},

          { path:"Approve-Reject", canActivate: [AuthenticationGuard], component: AppOrRejComponent},
          { path:"Meetings", canActivate: [AuthenticationGuard], component: MeetingsComponent},
          { path:"Reports",canActivate: [AuthenticationGuard],  component: ReportsComponent},
          { path:"office-bearer-approval",canActivate: [AuthenticationGuard],  component: OfficeBearerApprovalComponent},
          { path:"da-report", canActivate: [AuthenticationGuard], component: DaReportComponent},
          { path:"menu-change-password",canActivate: [AuthenticationGuard],  component: MenuChangePasswordComponent},
          { path:"ob-report", canActivate:[AuthenticationGuard], component: ObReportComponent},
	  { path:"activity", canActivate:[AuthenticationGuard], component: ActivityComponent},
	  { path: "activity-summary",canActivate:[AuthenticationGuard],  component: ActivitySummaryComponent },
	  { path:"course", canActivate:[AuthenticationGuard], component: CourseComponent},
          { path:"da-address", canActivate:[AuthenticationGuard], component: DaAddressreportComponent },
          { path:"zone-report", canActivate:[AuthenticationGuard], component: ZoneReportComponent},
         { path:"profile", canActivate:[AuthenticationGuard], component: ProfileDetailsComponent },
          // { path:"Addtional-post-approval",canActivate: [AuthenticationGuard],  component: AddtionalPostReqApprovalComponent},
          { path:"Winner-List",canActivate: [AuthenticationGuard],  component: Kalaignar100Component},
          { path:"Winner_List_show",canActivate: [AuthenticationGuard],  component: Kalaignar100ReportComponent},
        // { path:"attendance",canActivate: [AuthenticationGuard],  component: CourseAttendanceComponent},
        { path:"mc-list", canActivate:[AuthenticationGuard], component:MentorCreateCourseListComponent}

          ],},
 
  {path:"districtadmin",canActivate: [AuthenticationGuard], component: DistrictadminMenuComponent ,
            children: [
              { path: '', canActivate: [AuthenticationGuard], component: DaDashboardComponent},
              { path: 'Dashboard',canActivate: [AuthenticationGuard],  component: DaDashboardComponent},
              { path: 'create-office-bearers',canActivate: [AuthenticationGuard],  component: CreateOffBearerComponent},
              { path: 'appoint-district-office-bearers', canActivate: [AuthenticationGuard], component: AppointDistrictOffBearerComponent},
              { path: 'request-office-bearers-change', canActivate: [AuthenticationGuard], component: ReqOffBearerChangeComponent},
              { path: 'meetings',canActivate: [AuthenticationGuard],  component: DaMeetingComponent},
              { path:"menu-change-password",canActivate: [AuthenticationGuard],  component: MenuChangePasswordComponent},
              { path:"profile", canActivate:[AuthenticationGuard], component: ProfileDetailsComponent },
              { path:"course-district", canActivate:[AuthenticationGuard], component: CourseDistrictComponent },
               { path:"Winner-List",canActivate: [AuthenticationGuard],  component: Kalaignar100Component},
              { path: "Winner_List_show", canActivate: [AuthenticationGuard], component: Kalaignar100ReportComponent },
              { path:"dastudent",canActivate: [AuthenticationGuard],  component: DastudentlistComponent},
              { path:"damentor",canActivate: [AuthenticationGuard],  component: DaMentorlistComponent},
              { path:"course-attendance",canActivate: [AuthenticationGuard],  component: CourseAttendanceComponent},
              // { path:"volunteer-session",canActivate: [AuthenticationGuard],  component: VolunteerSessionComponent},
              { path:"dastudent-feedback",canActivate: [AuthenticationGuard],  component: DaStudentFeedbackComponent},
              { path:"damentor-feedback",canActivate: [AuthenticationGuard],  component: DaMentorFeedbackComponent},
              {
                path:'mentor-session',canActivate: [AuthenticationGuard], component: MentorSessionComponent
              },

                // merge code
                { path:"volunteer-session",canActivate: [AuthenticationGuard],  component: VolunteerSessionComponent},
                { path:"da-mentor-volunteer",canActivate: [AuthenticationGuard],  component: DaMentorVolunteerComponent},
            


    ],
  },

 
  {
    path: "student", canActivate: [AuthenticationGuard], component: StudentDashboardComponent,
    children: [
      {
        path:'',canActivate: [AuthenticationGuard], component: StDashboardComponent
      },
      {
        path:'stcourse',canActivate: [AuthenticationGuard], component: StCourseComponent
      },
       {
        path:'stchangePassword',canActivate: [AuthenticationGuard], component: StudentChangePasswordComponent
      },
       {
        path:'stdashboard',canActivate: [AuthenticationGuard], component: StDashboardComponent
      },
      {
        path:'studentFeedback',canActivate: [AuthenticationGuard], component: StudentFeedbackComponent
      },

      {
        path:'mentorstudentcourse',canActivate: [AuthenticationGuard], component: MentorStudentCourseComponent
      },
      
      {
        path:'studentrequestlist',canActivate: [AuthenticationGuard], component: StudentRequestListComponent
      },
      {
        path:'studentgrouprequestlist',canActivate: [AuthenticationGuard], component: StudentGroupRequestListComponent
      },
    ]
  },
  {
    path: "mentors", canActivate: [AuthenticationGuard], component: MentorDashboardComponent,
    children: [
      {
        path:'',canActivate: [AuthenticationGuard], component: MtDashboardComponent
      },
      {
        path:'mentor-session',canActivate: [AuthenticationGuard], component: MentorSessionComponent
      },
       {
        path:'mtchangePassword',canActivate: [AuthenticationGuard], component: MentorChangepasswordComponent
      },
      {
        path:'courseAssignedMentor',canActivate: [AuthenticationGuard], component: CourseAssignedComponent
      },
        {
        path:'mentorFeedback',canActivate: [AuthenticationGuard], component: MentorFeedbackComponent
      },
        {
        path:'mtdashboard',canActivate: [AuthenticationGuard], component: MtdashboardComponent
      },
      {
        path:'mentorcourselist',canActivate: [AuthenticationGuard], component: MentorlistComponent
      },
      {
        path:'mentorstudentrequest',canActivate: [AuthenticationGuard],component:MentorstudentrequestComponent
      },
      {
        path:'mentorstudentgrouprequest',canActivate: [AuthenticationGuard],component:MentorstudentgrouprequestComponent
      },
      {
        path:'studentenroll',canActivate: [AuthenticationGuard],component:StudentEnrollComponent
      },
      // {
      //   path: 'mentor-volunteer', canActivate: [AuthenticationGuard], component: MentorVolunteerComponent
      // }
    ]
  },
  {path:"forgot_password", component: ForgotPasswordComponent},
  {path:"self-registration", component: SelfRegistrationComponent},
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {path:"**",redirectTo:'', component: LoginComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
